// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { VerifaiCreatorView, VerifaiOverviewItem, VerifaiContentStatus, VerifaiFormatType, VerifaiRating, VerifaiCreatorViewResult } from "../schema";

export function serialize_VerifaiCreatorViewResult(obj: VerifaiCreatorViewResult): string {
  const serialized = ((value: { kind: "NOT_FOUND_ERROR" } | { kind: "IDENTITY_NOT_CONFIRMED_ERROR" } | { kind: "SUCCESS"; data: VerifaiCreatorView }): unknown => {
    switch (value.kind) {
      case "NOT_FOUND_ERROR": {
        return { kind: "NOT_FOUND_ERROR" };
      }
      case "IDENTITY_NOT_CONFIRMED_ERROR": {
        return { kind: "IDENTITY_NOT_CONFIRMED_ERROR" };
      }
      case "SUCCESS": {
        return {
          kind: "SUCCESS",
          data: ((value: { authorName: string; claimableItems: VerifaiOverviewItem[]; claimedItems: VerifaiOverviewItem[] }): unknown => {
            return {
              authorName: ((value: string): unknown => {
                return value;
              })(value["authorName"]),
              claimableItems: ((value: VerifaiOverviewItem[]): unknown => {
                return value.map(
                  (value: {
                    contentStatus: VerifaiContentStatus;
                    editor: string;
                    formatType: VerifaiFormatType;
                    hashId: string;
                    invoiced: boolean;
                    publisher: string;
                    rating: VerifaiRating;
                    resourceUrl: string;
                    title: string;
                    uploader: string;
                    verifaiContentId: bigint;
                    verifier: string;
                  }): unknown => {
                    return {
                      contentStatus: ((value: "PREPROCESSING" | "OPEN" | "ASSIGNED" | "SUBMITTED" | "EDITED" | "REJECTED" | "ARCHIVED" | "PUBLISHED"): unknown => {
                        return value;
                      })(value["contentStatus"]),
                      editor: ((value: string): unknown => {
                        return value;
                      })(value["editor"]),
                      formatType: ((value: "ARTICLE" | "BLOGPOST" | "PODCAST" | "REPORT" | "VIDEO"): unknown => {
                        return value;
                      })(value["formatType"]),
                      hashId: ((value: string): unknown => {
                        return value;
                      })(value["hashId"]),
                      invoiced: ((value: boolean): unknown => {
                        return value;
                      })(value["invoiced"]),
                      publisher: ((value: string): unknown => {
                        return value;
                      })(value["publisher"]),
                      rating: ((value: "A" | "B" | "C" | "F"): unknown => {
                        return value;
                      })(value["rating"]),
                      resourceUrl: ((value: string): unknown => {
                        return value;
                      })(value["resourceUrl"]),
                      title: ((value: string): unknown => {
                        return value;
                      })(value["title"]),
                      uploader: ((value: string): unknown => {
                        return value;
                      })(value["uploader"]),
                      verifaiContentId: ((value: bigint): unknown => {
                        return value;
                      })(value["verifaiContentId"]),
                      verifier: ((value: string): unknown => {
                        return value;
                      })(value["verifier"]),
                    };
                  },
                );
              })(value["claimableItems"]),
              claimedItems: ((value: VerifaiOverviewItem[]): unknown => {
                return value.map(
                  (value: {
                    contentStatus: VerifaiContentStatus;
                    editor: string;
                    formatType: VerifaiFormatType;
                    hashId: string;
                    invoiced: boolean;
                    publisher: string;
                    rating: VerifaiRating;
                    resourceUrl: string;
                    title: string;
                    uploader: string;
                    verifaiContentId: bigint;
                    verifier: string;
                  }): unknown => {
                    return {
                      contentStatus: ((value: "PREPROCESSING" | "OPEN" | "ASSIGNED" | "SUBMITTED" | "EDITED" | "REJECTED" | "ARCHIVED" | "PUBLISHED"): unknown => {
                        return value;
                      })(value["contentStatus"]),
                      editor: ((value: string): unknown => {
                        return value;
                      })(value["editor"]),
                      formatType: ((value: "ARTICLE" | "BLOGPOST" | "PODCAST" | "REPORT" | "VIDEO"): unknown => {
                        return value;
                      })(value["formatType"]),
                      hashId: ((value: string): unknown => {
                        return value;
                      })(value["hashId"]),
                      invoiced: ((value: boolean): unknown => {
                        return value;
                      })(value["invoiced"]),
                      publisher: ((value: string): unknown => {
                        return value;
                      })(value["publisher"]),
                      rating: ((value: "A" | "B" | "C" | "F"): unknown => {
                        return value;
                      })(value["rating"]),
                      resourceUrl: ((value: string): unknown => {
                        return value;
                      })(value["resourceUrl"]),
                      title: ((value: string): unknown => {
                        return value;
                      })(value["title"]),
                      uploader: ((value: string): unknown => {
                        return value;
                      })(value["uploader"]),
                      verifaiContentId: ((value: bigint): unknown => {
                        return value;
                      })(value["verifaiContentId"]),
                      verifier: ((value: string): unknown => {
                        return value;
                      })(value["verifier"]),
                    };
                  },
                );
              })(value["claimedItems"]),
            };
          })(value["data"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_VerifaiCreatorViewResult(str: string): ParserResult<VerifaiCreatorViewResult> {
  return ((value: unknown): ParserResult<{ kind: "NOT_FOUND_ERROR" } | { kind: "IDENTITY_NOT_CONFIRMED_ERROR" } | { kind: "SUCCESS"; data: VerifaiCreatorView }> => {
    return ((value: unknown): ParserResult<{ kind: "NOT_FOUND_ERROR" } | { kind: "IDENTITY_NOT_CONFIRMED_ERROR" } | { kind: "SUCCESS"; data: VerifaiCreatorView }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "NOT_FOUND_ERROR": {
          const parsedVariant = ((value: unknown): ParserResult<Record<string, never>> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult/NOT_FOUND_ERROR]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult/NOT_FOUND_ERROR]: '${value}' expected to not be null.` };
            }
            return { success: true, value: {} };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "NOT_FOUND_ERROR" as const, ...parsedVariant.value } };
        }
        case "IDENTITY_NOT_CONFIRMED_ERROR": {
          const parsedVariant = ((value: unknown): ParserResult<Record<string, never>> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult/IDENTITY_NOT_CONFIRMED_ERROR]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult/IDENTITY_NOT_CONFIRMED_ERROR]: '${value}' expected to not be null.` };
            }
            return { success: true, value: {} };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "IDENTITY_NOT_CONFIRMED_ERROR" as const, ...parsedVariant.value } };
        }
        case "SUCCESS": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            data: VerifaiCreatorView;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult/SUCCESS]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult/SUCCESS]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "data")) {
              return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult/SUCCESS/data]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'data'.` };
            }
            const parsed_data = ((): ParserResult<VerifaiCreatorView> => {
              return ((value: unknown): ParserResult<VerifaiCreatorView> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  authorName: string;
                  claimableItems: VerifaiOverviewItem[];
                  claimedItems: VerifaiOverviewItem[];
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/VerifaiCreatorView]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/VerifaiCreatorView]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "authorName")) {
                    return { success: false, reason: `[#/components/schemas/VerifaiCreatorView/authorName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorName'.` };
                  }
                  const parsed_authorName = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/VerifaiCreatorView/authorName]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["authorName"]);
                  })();
                  if (!parsed_authorName.success) {
                    return { success: false, reason: parsed_authorName.reason };
                  }
                  if (!hasProp(value, "claimableItems")) {
                    return { success: false, reason: `[#/components/schemas/VerifaiCreatorView/claimableItems]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'claimableItems'.` };
                  }
                  const parsed_claimableItems = ((): ParserResult<VerifaiOverviewItem[]> => {
                    return ((value: unknown): ParserResult<VerifaiOverviewItem[]> => {
                      if (!isArray(value)) {
                        return { success: false, reason: `[#/components/schemas/VerifaiCreatorView/claimableItems]: '${value}' expected to be an array.` };
                      }
                      const parsed = value.map((value: unknown): ParserResult<VerifaiOverviewItem> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          contentStatus: VerifaiContentStatus;
                          editor: string;
                          formatType: VerifaiFormatType;
                          hashId: string;
                          invoiced: boolean;
                          publisher: string;
                          rating: VerifaiRating;
                          resourceUrl: string;
                          title: string;
                          uploader: string;
                          verifaiContentId: bigint;
                          verifier: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "contentStatus")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/contentStatus]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentStatus'.` };
                          }
                          const parsed_contentStatus = ((): ParserResult<VerifaiContentStatus> => {
                            return ((value: unknown): ParserResult<VerifaiContentStatus> => {
                              return ((value: unknown): ParserResult<"PREPROCESSING" | "OPEN" | "ASSIGNED" | "SUBMITTED" | "EDITED" | "REJECTED" | "ARCHIVED" | "PUBLISHED"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/VerifaiContentStatus]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "PREPROCESSING":
                                    return { success: true, value: "PREPROCESSING" };
                                  case "OPEN":
                                    return { success: true, value: "OPEN" };
                                  case "ASSIGNED":
                                    return { success: true, value: "ASSIGNED" };
                                  case "SUBMITTED":
                                    return { success: true, value: "SUBMITTED" };
                                  case "EDITED":
                                    return { success: true, value: "EDITED" };
                                  case "REJECTED":
                                    return { success: true, value: "REJECTED" };
                                  case "ARCHIVED":
                                    return { success: true, value: "ARCHIVED" };
                                  case "PUBLISHED":
                                    return { success: true, value: "PUBLISHED" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/VerifaiContentStatus]: '${value}' expected to be enum, one of 'PREPROCESSING, OPEN, ASSIGNED, SUBMITTED, EDITED, REJECTED, ARCHIVED, PUBLISHED'.` };
                                }
                              })(value);
                            })(value["contentStatus"]);
                          })();
                          if (!parsed_contentStatus.success) {
                            return { success: false, reason: parsed_contentStatus.reason };
                          }
                          if (!hasProp(value, "editor")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/editor]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'editor'.` };
                          }
                          const parsed_editor = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/editor]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["editor"]);
                          })();
                          if (!parsed_editor.success) {
                            return { success: false, reason: parsed_editor.reason };
                          }
                          if (!hasProp(value, "formatType")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/formatType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'formatType'.` };
                          }
                          const parsed_formatType = ((): ParserResult<VerifaiFormatType> => {
                            return ((value: unknown): ParserResult<VerifaiFormatType> => {
                              return ((value: unknown): ParserResult<"ARTICLE" | "BLOGPOST" | "PODCAST" | "REPORT" | "VIDEO"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/VerifaiFormatType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "ARTICLE":
                                    return { success: true, value: "ARTICLE" };
                                  case "BLOGPOST":
                                    return { success: true, value: "BLOGPOST" };
                                  case "PODCAST":
                                    return { success: true, value: "PODCAST" };
                                  case "REPORT":
                                    return { success: true, value: "REPORT" };
                                  case "VIDEO":
                                    return { success: true, value: "VIDEO" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/VerifaiFormatType]: '${value}' expected to be enum, one of 'ARTICLE, BLOGPOST, PODCAST, REPORT, VIDEO'.` };
                                }
                              })(value);
                            })(value["formatType"]);
                          })();
                          if (!parsed_formatType.success) {
                            return { success: false, reason: parsed_formatType.reason };
                          }
                          if (!hasProp(value, "hashId")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/hashId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'hashId'.` };
                          }
                          const parsed_hashId = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/hashId]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["hashId"]);
                          })();
                          if (!parsed_hashId.success) {
                            return { success: false, reason: parsed_hashId.reason };
                          }
                          if (!hasProp(value, "invoiced")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/invoiced]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'invoiced'.` };
                          }
                          const parsed_invoiced = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/invoiced]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["invoiced"]);
                          })();
                          if (!parsed_invoiced.success) {
                            return { success: false, reason: parsed_invoiced.reason };
                          }
                          if (!hasProp(value, "publisher")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/publisher]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publisher'.` };
                          }
                          const parsed_publisher = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/publisher]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["publisher"]);
                          })();
                          if (!parsed_publisher.success) {
                            return { success: false, reason: parsed_publisher.reason };
                          }
                          if (!hasProp(value, "rating")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/rating]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'rating'.` };
                          }
                          const parsed_rating = ((): ParserResult<VerifaiRating> => {
                            return ((value: unknown): ParserResult<VerifaiRating> => {
                              return ((value: unknown): ParserResult<"A" | "B" | "C" | "F"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/VerifaiRating]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "A":
                                    return { success: true, value: "A" };
                                  case "B":
                                    return { success: true, value: "B" };
                                  case "C":
                                    return { success: true, value: "C" };
                                  case "F":
                                    return { success: true, value: "F" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/VerifaiRating]: '${value}' expected to be enum, one of 'A, B, C, F'.` };
                                }
                              })(value);
                            })(value["rating"]);
                          })();
                          if (!parsed_rating.success) {
                            return { success: false, reason: parsed_rating.reason };
                          }
                          if (!hasProp(value, "resourceUrl")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/resourceUrl]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'resourceUrl'.` };
                          }
                          const parsed_resourceUrl = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/resourceUrl]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["resourceUrl"]);
                          })();
                          if (!parsed_resourceUrl.success) {
                            return { success: false, reason: parsed_resourceUrl.reason };
                          }
                          if (!hasProp(value, "title")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                          }
                          const parsed_title = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/title]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["title"]);
                          })();
                          if (!parsed_title.success) {
                            return { success: false, reason: parsed_title.reason };
                          }
                          if (!hasProp(value, "uploader")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/uploader]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'uploader'.` };
                          }
                          const parsed_uploader = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/uploader]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["uploader"]);
                          })();
                          if (!parsed_uploader.success) {
                            return { success: false, reason: parsed_uploader.reason };
                          }
                          if (!hasProp(value, "verifaiContentId")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifaiContentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifaiContentId'.` };
                          }
                          const parsed_verifaiContentId = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifaiContentId]: '${value}' expected to be of type bigint or number.` };
                            })(value["verifaiContentId"]);
                          })();
                          if (!parsed_verifaiContentId.success) {
                            return { success: false, reason: parsed_verifaiContentId.reason };
                          }
                          if (!hasProp(value, "verifier")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifier]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifier'.` };
                          }
                          const parsed_verifier = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifier]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["verifier"]);
                          })();
                          if (!parsed_verifier.success) {
                            return { success: false, reason: parsed_verifier.reason };
                          }
                          return {
                            success: true,
                            value: {
                              contentStatus: parsed_contentStatus.value,
                              editor: parsed_editor.value,
                              formatType: parsed_formatType.value,
                              hashId: parsed_hashId.value,
                              invoiced: parsed_invoiced.value,
                              publisher: parsed_publisher.value,
                              rating: parsed_rating.value,
                              resourceUrl: parsed_resourceUrl.value,
                              title: parsed_title.value,
                              uploader: parsed_uploader.value,
                              verifaiContentId: parsed_verifaiContentId.value,
                              verifier: parsed_verifier.value,
                            },
                          };
                        })(value);
                      });
                      if (parsed.find((value) => !value.success) !== undefined) {
                        return {
                          success: false,
                          reason: `[#/components/schemas/VerifaiCreatorView/claimableItems]: Reason(s): '${parsed
                            .filter((p) => !p.success)
                            .map((p) => p.reason)
                            .join(", ")}'.`,
                        };
                      }
                      return {
                        success: true,
                        value: parsed.map((entry) => {
                          assert(entry.success == true);
                          return entry.value;
                        }),
                      };
                    })(value["claimableItems"]);
                  })();
                  if (!parsed_claimableItems.success) {
                    return { success: false, reason: parsed_claimableItems.reason };
                  }
                  if (!hasProp(value, "claimedItems")) {
                    return { success: false, reason: `[#/components/schemas/VerifaiCreatorView/claimedItems]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'claimedItems'.` };
                  }
                  const parsed_claimedItems = ((): ParserResult<VerifaiOverviewItem[]> => {
                    return ((value: unknown): ParserResult<VerifaiOverviewItem[]> => {
                      if (!isArray(value)) {
                        return { success: false, reason: `[#/components/schemas/VerifaiCreatorView/claimedItems]: '${value}' expected to be an array.` };
                      }
                      const parsed = value.map((value: unknown): ParserResult<VerifaiOverviewItem> => {
                        return ((
                          value: unknown,
                        ): ParserResult<{
                          contentStatus: VerifaiContentStatus;
                          editor: string;
                          formatType: VerifaiFormatType;
                          hashId: string;
                          invoiced: boolean;
                          publisher: string;
                          rating: VerifaiRating;
                          resourceUrl: string;
                          title: string;
                          uploader: string;
                          verifaiContentId: bigint;
                          verifier: string;
                        }> => {
                          if (typeof value !== "object") {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem]: '${value}' expected to be of type 'object'.` };
                          }
                          if (value === null) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem]: '${value}' expected to not be null.` };
                          }
                          if (!hasProp(value, "contentStatus")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/contentStatus]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentStatus'.` };
                          }
                          const parsed_contentStatus = ((): ParserResult<VerifaiContentStatus> => {
                            return ((value: unknown): ParserResult<VerifaiContentStatus> => {
                              return ((value: unknown): ParserResult<"PREPROCESSING" | "OPEN" | "ASSIGNED" | "SUBMITTED" | "EDITED" | "REJECTED" | "ARCHIVED" | "PUBLISHED"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/VerifaiContentStatus]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "PREPROCESSING":
                                    return { success: true, value: "PREPROCESSING" };
                                  case "OPEN":
                                    return { success: true, value: "OPEN" };
                                  case "ASSIGNED":
                                    return { success: true, value: "ASSIGNED" };
                                  case "SUBMITTED":
                                    return { success: true, value: "SUBMITTED" };
                                  case "EDITED":
                                    return { success: true, value: "EDITED" };
                                  case "REJECTED":
                                    return { success: true, value: "REJECTED" };
                                  case "ARCHIVED":
                                    return { success: true, value: "ARCHIVED" };
                                  case "PUBLISHED":
                                    return { success: true, value: "PUBLISHED" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/VerifaiContentStatus]: '${value}' expected to be enum, one of 'PREPROCESSING, OPEN, ASSIGNED, SUBMITTED, EDITED, REJECTED, ARCHIVED, PUBLISHED'.` };
                                }
                              })(value);
                            })(value["contentStatus"]);
                          })();
                          if (!parsed_contentStatus.success) {
                            return { success: false, reason: parsed_contentStatus.reason };
                          }
                          if (!hasProp(value, "editor")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/editor]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'editor'.` };
                          }
                          const parsed_editor = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/editor]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["editor"]);
                          })();
                          if (!parsed_editor.success) {
                            return { success: false, reason: parsed_editor.reason };
                          }
                          if (!hasProp(value, "formatType")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/formatType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'formatType'.` };
                          }
                          const parsed_formatType = ((): ParserResult<VerifaiFormatType> => {
                            return ((value: unknown): ParserResult<VerifaiFormatType> => {
                              return ((value: unknown): ParserResult<"ARTICLE" | "BLOGPOST" | "PODCAST" | "REPORT" | "VIDEO"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/VerifaiFormatType]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "ARTICLE":
                                    return { success: true, value: "ARTICLE" };
                                  case "BLOGPOST":
                                    return { success: true, value: "BLOGPOST" };
                                  case "PODCAST":
                                    return { success: true, value: "PODCAST" };
                                  case "REPORT":
                                    return { success: true, value: "REPORT" };
                                  case "VIDEO":
                                    return { success: true, value: "VIDEO" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/VerifaiFormatType]: '${value}' expected to be enum, one of 'ARTICLE, BLOGPOST, PODCAST, REPORT, VIDEO'.` };
                                }
                              })(value);
                            })(value["formatType"]);
                          })();
                          if (!parsed_formatType.success) {
                            return { success: false, reason: parsed_formatType.reason };
                          }
                          if (!hasProp(value, "hashId")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/hashId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'hashId'.` };
                          }
                          const parsed_hashId = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/hashId]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["hashId"]);
                          })();
                          if (!parsed_hashId.success) {
                            return { success: false, reason: parsed_hashId.reason };
                          }
                          if (!hasProp(value, "invoiced")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/invoiced]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'invoiced'.` };
                          }
                          const parsed_invoiced = ((): ParserResult<boolean> => {
                            return ((value: unknown): ParserResult<boolean> => {
                              if (typeof value !== "boolean") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/invoiced]: '${value}' expected to be of type boolean.` };
                              }
                              return { success: true, value: value };
                            })(value["invoiced"]);
                          })();
                          if (!parsed_invoiced.success) {
                            return { success: false, reason: parsed_invoiced.reason };
                          }
                          if (!hasProp(value, "publisher")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/publisher]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publisher'.` };
                          }
                          const parsed_publisher = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/publisher]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["publisher"]);
                          })();
                          if (!parsed_publisher.success) {
                            return { success: false, reason: parsed_publisher.reason };
                          }
                          if (!hasProp(value, "rating")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/rating]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'rating'.` };
                          }
                          const parsed_rating = ((): ParserResult<VerifaiRating> => {
                            return ((value: unknown): ParserResult<VerifaiRating> => {
                              return ((value: unknown): ParserResult<"A" | "B" | "C" | "F"> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/VerifaiRating]: '${value}' expected to be of type string.` };
                                }
                                switch (value) {
                                  case "A":
                                    return { success: true, value: "A" };
                                  case "B":
                                    return { success: true, value: "B" };
                                  case "C":
                                    return { success: true, value: "C" };
                                  case "F":
                                    return { success: true, value: "F" };
                                  default:
                                    return { success: false, reason: `[#/components/schemas/VerifaiRating]: '${value}' expected to be enum, one of 'A, B, C, F'.` };
                                }
                              })(value);
                            })(value["rating"]);
                          })();
                          if (!parsed_rating.success) {
                            return { success: false, reason: parsed_rating.reason };
                          }
                          if (!hasProp(value, "resourceUrl")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/resourceUrl]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'resourceUrl'.` };
                          }
                          const parsed_resourceUrl = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/resourceUrl]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["resourceUrl"]);
                          })();
                          if (!parsed_resourceUrl.success) {
                            return { success: false, reason: parsed_resourceUrl.reason };
                          }
                          if (!hasProp(value, "title")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
                          }
                          const parsed_title = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/title]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["title"]);
                          })();
                          if (!parsed_title.success) {
                            return { success: false, reason: parsed_title.reason };
                          }
                          if (!hasProp(value, "uploader")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/uploader]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'uploader'.` };
                          }
                          const parsed_uploader = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/uploader]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["uploader"]);
                          })();
                          if (!parsed_uploader.success) {
                            return { success: false, reason: parsed_uploader.reason };
                          }
                          if (!hasProp(value, "verifaiContentId")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifaiContentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifaiContentId'.` };
                          }
                          const parsed_verifaiContentId = ((): ParserResult<bigint> => {
                            return ((value: unknown): ParserResult<bigint> => {
                              if (typeof value === "number") {
                                return { success: true, value: BigInt(value) };
                              }
                              if (typeof value === "bigint") {
                                return { success: true, value: value };
                              }
                              return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifaiContentId]: '${value}' expected to be of type bigint or number.` };
                            })(value["verifaiContentId"]);
                          })();
                          if (!parsed_verifaiContentId.success) {
                            return { success: false, reason: parsed_verifaiContentId.reason };
                          }
                          if (!hasProp(value, "verifier")) {
                            return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifier]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifier'.` };
                          }
                          const parsed_verifier = ((): ParserResult<string> => {
                            return ((value: unknown): ParserResult<string> => {
                              if (typeof value !== "string") {
                                return { success: false, reason: `[#/components/schemas/VerifaiOverviewItem/verifier]: '${value}' expected to be of type string.` };
                              }
                              return { success: true, value: value };
                            })(value["verifier"]);
                          })();
                          if (!parsed_verifier.success) {
                            return { success: false, reason: parsed_verifier.reason };
                          }
                          return {
                            success: true,
                            value: {
                              contentStatus: parsed_contentStatus.value,
                              editor: parsed_editor.value,
                              formatType: parsed_formatType.value,
                              hashId: parsed_hashId.value,
                              invoiced: parsed_invoiced.value,
                              publisher: parsed_publisher.value,
                              rating: parsed_rating.value,
                              resourceUrl: parsed_resourceUrl.value,
                              title: parsed_title.value,
                              uploader: parsed_uploader.value,
                              verifaiContentId: parsed_verifaiContentId.value,
                              verifier: parsed_verifier.value,
                            },
                          };
                        })(value);
                      });
                      if (parsed.find((value) => !value.success) !== undefined) {
                        return {
                          success: false,
                          reason: `[#/components/schemas/VerifaiCreatorView/claimedItems]: Reason(s): '${parsed
                            .filter((p) => !p.success)
                            .map((p) => p.reason)
                            .join(", ")}'.`,
                        };
                      }
                      return {
                        success: true,
                        value: parsed.map((entry) => {
                          assert(entry.success == true);
                          return entry.value;
                        }),
                      };
                    })(value["claimedItems"]);
                  })();
                  if (!parsed_claimedItems.success) {
                    return { success: false, reason: parsed_claimedItems.reason };
                  }
                  return { success: true, value: { authorName: parsed_authorName.value, claimableItems: parsed_claimableItems.value, claimedItems: parsed_claimedItems.value } };
                })(value);
              })(value["data"]);
            })();
            if (!parsed_data.success) {
              return { success: false, reason: parsed_data.reason };
            }
            return { success: true, value: { data: parsed_data.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "SUCCESS" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/VerifaiCreatorViewResult]: '${discriminator}' expected to be one of 'NOT_FOUND_ERROR, IDENTITY_NOT_CONFIRMED_ERROR, SUCCESS'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}
